(function(){
  function init(root){
    if(!root || root.dataset.fmB6Ready==='true') return;
    root.dataset.fmB6Ready='true';

    var desktop=window.matchMedia('(min-width:1024px)');
    var hoverCapable=window.matchMedia('(hover:hover) and (pointer:fine)');
    var triggers=Array.prototype.slice.call(root.querySelectorAll('[data-fm-b6-trigger]'));
    var directTopLinks=Array.prototype.slice.call(root.querySelectorAll('.fm-b6-mega__top-control:not([data-fm-b6-trigger])'));
    var popovers=Array.prototype.slice.call(root.querySelectorAll('[data-fm-b6-popover]'));

    var restaurantCategories=Array.prototype.slice.call(root.querySelectorAll('[data-fm-b6-category]'));
    var restaurantPanels=Array.prototype.slice.call(root.querySelectorAll('[data-fm-b6-panel]'));
    var restaurantPopover=root.querySelector('[data-fm-b6-popover="restaurant"]');
    var restaurantContent=restaurantPopover ? restaurantPopover.querySelector('.fm-b6-mega__content') : null;

    var gameCategories=Array.prototype.slice.call(root.querySelectorAll('[data-fm-b6-games-category]'));
    var gamePanels=Array.prototype.slice.call(root.querySelectorAll('[data-fm-b6-games-panel]'));
    var gamesPopover=root.querySelector('[data-fm-b6-popover="games"]');
    var gamesContent=gamesPopover ? gamesPopover.querySelector('[data-fm-b6-games-content]') : null;


    var activeTrigger=null;
    var hoverTimer=null;
    var closeTimer=null;

    function clearTimer(name){
      if(name==='hover' && hoverTimer){window.clearTimeout(hoverTimer);hoverTimer=null;}
      if(name==='close' && closeTimer){window.clearTimeout(closeTimer);closeTimer=null;}
    }

    function updateScrollState(popover,content){
      if(!content || !popover) return;
      var scrollable=content.scrollHeight > content.clientHeight + 2;
      var atBottom=!scrollable || content.scrollTop + content.clientHeight >= content.scrollHeight - 2;
      content.classList.toggle('is-scrollable',scrollable);
      content.classList.toggle('is-at-bottom',atBottom);
      popover.classList.toggle('has-more-below',scrollable && !atBottom);
    }

    function resetScroll(popover,content){
      if(!content) return;
      content.scrollTop=0;
      window.requestAnimationFrame(function(){updateScrollState(popover,content);});
    }

    function setScopedCategory(button,buttons,panels,buttonAttr,panelAttr,popover,content){
      if(!button) return;
      var key=button.getAttribute(buttonAttr);
      buttons.forEach(function(item){
        var active=item===button;
        item.classList.toggle('is-active',active);
        item.setAttribute('aria-expanded',active?'true':'false');
      });
      panels.forEach(function(panel){
        panel.hidden=panel.getAttribute(panelAttr)!==key;
      });
      resetScroll(popover,content);
    }

    function setRestaurantCategory(button){
      setScopedCategory(button,restaurantCategories,restaurantPanels,'data-fm-b6-category','data-fm-b6-panel',restaurantPopover,restaurantContent);
    }

    function setGameCategory(button){
      setScopedCategory(button,gameCategories,gamePanels,'data-fm-b6-games-category','data-fm-b6-games-panel',gamesPopover,gamesContent);
    }

    function ensureCategory(buttons,setter){
      var current=buttons.find(function(item){return item.classList.contains('is-active');});
      setter(current||buttons[0]);
    }

    function closeAll(options){
      clearTimer('hover');
      clearTimer('close');
      popovers.forEach(function(popover){popover.hidden=true;});
      triggers.forEach(function(trigger){
        trigger.classList.remove('is-active');
        trigger.setAttribute('aria-expanded','false');
      });
      var previous=activeTrigger;
      activeTrigger=null;
      if(options && options.restoreFocus && previous) previous.focus();
    }

    function openTrigger(trigger){
      if(!desktop.matches || !trigger) return;
      var id=trigger.getAttribute('aria-controls');
      var popover=id ? document.getElementById(id) : null;
      if(!popover) return;

      clearTimer('hover');
      clearTimer('close');

      popovers.forEach(function(item){item.hidden=item!==popover;});
      triggers.forEach(function(item){
        var active=item===trigger;
        item.classList.toggle('is-active',active);
        item.setAttribute('aria-expanded',active?'true':'false');
      });

      activeTrigger=trigger;
      var type=trigger.getAttribute('data-fm-b6-trigger');
      if(type==='restaurant') ensureCategory(restaurantCategories,setRestaurantCategory);
      if(type==='games') ensureCategory(gameCategories,setGameCategory);
    }

    function toggleTrigger(trigger){
      if(trigger===activeTrigger && trigger.getAttribute('aria-expanded')==='true') closeAll();
      else openTrigger(trigger);
    }

    function scheduleOpen(trigger){
      if(!hoverCapable.matches) return;
      clearTimer('hover');
      hoverTimer=window.setTimeout(function(){openTrigger(trigger);},180);
    }

    function bindCategoryGroup(buttons,setter){
      buttons.forEach(function(button,index){
        button.addEventListener('click',function(){setter(button);});
        button.addEventListener('mouseenter',function(){
          if(!hoverCapable.matches) return;
          clearTimer('hover');
          hoverTimer=window.setTimeout(function(){setter(button);},120);
        });
        button.addEventListener('keydown',function(event){
          var next=index;
          if(event.key==='ArrowDown') next=(index+1)%buttons.length;
          else if(event.key==='ArrowUp') next=(index-1+buttons.length)%buttons.length;
          else return;
          event.preventDefault();
          buttons[next].focus();
          setter(buttons[next]);
        });
      });
    }

    triggers.forEach(function(trigger){
      trigger.addEventListener('click',function(event){
        event.preventDefault();
        toggleTrigger(trigger);
      });
      trigger.addEventListener('mouseenter',function(){scheduleOpen(trigger);});
    });

    directTopLinks.forEach(function(link){
      link.addEventListener('mouseenter',function(){
        if(hoverCapable.matches) closeAll();
      });
      link.addEventListener('focus',function(){closeAll();});
    });


    bindCategoryGroup(restaurantCategories,setRestaurantCategory);
    bindCategoryGroup(gameCategories,setGameCategory);

    var brandPreviewItems=Array.prototype.slice.call(root.querySelectorAll('[data-fm-b6-brand-preview]'));
    var brandPreviewLogo=root.querySelector('[data-fm-b6-brand-preview-logo]');
    var brandPreviewDesc=root.querySelector('[data-fm-b6-brand-preview-desc]');

    function setBrandPreview(item){
      if(!item || !brandPreviewLogo || !brandPreviewDesc) return;
      var name=item.getAttribute('data-brand-name') || '';
      var logo=item.getAttribute('data-brand-logo') || '';
      var desc=item.getAttribute('data-brand-desc') || '';
      if(logo){
        brandPreviewLogo.src=logo;
        brandPreviewLogo.alt=name;
      }
      brandPreviewDesc.textContent=desc;
      brandPreviewItems.forEach(function(other){
        other.classList.toggle('is-previewed',other===item);
      });
    }

    brandPreviewItems.forEach(function(item){
      item.addEventListener('mouseenter',function(){ setBrandPreview(item); });
      item.addEventListener('focus',function(){ setBrandPreview(item); });
    });

    root.addEventListener('mouseenter',function(){clearTimer('close');});
    root.addEventListener('mouseleave',function(){
      if(!hoverCapable.matches) return;
      clearTimer('hover');
      clearTimer('close');
      closeTimer=window.setTimeout(function(){closeAll();},240);
    });

    document.addEventListener('click',function(event){
      if(!root.contains(event.target)) closeAll();
    });

    document.addEventListener('keydown',function(event){
      if(event.key==='Escape' && activeTrigger) closeAll({restoreFocus:true});
    });

    if(restaurantContent){
      restaurantContent.addEventListener('scroll',function(){updateScrollState(restaurantPopover,restaurantContent);},{passive:true});
    }
    if(gamesContent){
      gamesContent.addEventListener('scroll',function(){updateScrollState(gamesPopover,gamesContent);},{passive:true});
    }

    window.addEventListener('resize',function(){
      if(!activeTrigger) return;
      var type=activeTrigger.getAttribute('data-fm-b6-trigger');
      if(type==='restaurant') window.requestAnimationFrame(function(){updateScrollState(restaurantPopover,restaurantContent);});
      if(type==='games') window.requestAnimationFrame(function(){updateScrollState(gamesPopover,gamesContent);});
    },{passive:true});

    function onBreakpoint(){
      if(!desktop.matches) closeAll();
    }
    if(desktop.addEventListener) desktop.addEventListener('change',onBreakpoint);
    else desktop.addListener(onBreakpoint);
  }

  function boot(scope){
    (scope||document).querySelectorAll('[data-fm-b6-mega]').forEach(init);
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){boot(document);});
  else boot(document);

  document.addEventListener('shopify:section:load',function(event){boot(event.target);});
})();